import React, { useEffect, useState, useRef } from 'react';
import ReactQuill from 'react-quill';
import DOMPurify from 'dompurify';
import { Button } from 'reactstrap';
import 'react-quill/dist/quill.snow.css';
export default function RichTextEditor(_a) {
    var _b = _a.initialContent, initialContent = _b === void 0 ? '' : _b, onEditorAccept = _a.onEditorAccept;
    var _c = useState(initialContent), content = _c[0], setContent = _c[1];
    var quillRef = useRef(null);
    useEffect(function () {
        setContent(initialContent);
    }, [initialContent]);
    var handleSave = function () {
        var _a;
        var editor = (_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor();
        if (!editor)
            return;
        var rawHtml = editor.root.innerHTML;
        var cleanHtml = DOMPurify.sanitize(rawHtml, {
            ALLOWED_TAGS: [
                'p', 'b', 'i', 'strong', 'em', 'u', 's', 'ul', 'ol', 'li', 'a', 'br', 'span',
                'h1', 'h2', 'h3', 'blockquote', 'pre', 'code', 'img'
            ],
            ALLOWED_ATTR: ['href', 'title', 'target', 'src', 'alt', 'style']
        });
        onEditorAccept(cleanHtml);
    };
    var modules = {
        toolbar: [
            [{ header: [1, 2, 3, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ color: [] }, { background: [] }],
            ['link', 'image'],
            ['clean']
        ],
        clipboard: { matchVisual: false }
    };
    var formats = [
        'header', 'bold', 'italic', 'underline', 'strike',
        'blockquote', 'code-block', 'list', 'bullet',
        'color', 'background', 'link', 'image'
    ];
    return (React.createElement("div", null,
        React.createElement("div", { style: { display: 'flex', flexDirection: 'column', gap: 8 } },
            React.createElement("div", { style: { height: 550 } },
                React.createElement(ReactQuill, { ref: quillRef, value: content, onChange: setContent, modules: modules, formats: formats, theme: "snow", style: { height: 500, marginBottom: 8 } })),
            React.createElement("div", { style: { display: 'flex', gap: 8 } },
                React.createElement(Button, { disabled: content === initialContent, onClick: handleSave }, "Aceptar cambios"),
                React.createElement(Button, { onClick: function () { var _a; return ((_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor()).history.undo(); } }, "\u21B6 Undo"),
                React.createElement(Button, { onClick: function () { var _a; return ((_a = quillRef.current) === null || _a === void 0 ? void 0 : _a.getEditor()).history.redo(); } }, "\u21B7 Redo")))));
}



//////////////////
// WEBPACK FOOTER
// ./src/components/RichTextEditor/RichTextEditor.tsx
// module id = 1506
// module chunks = 0